import { Service } from 'sp-mark/models/service.interface';

import { createAction, props } from '@ngrx/store';
import { LocalUnit, Payment, Receipt, Ticket, User } from 'sp-ui-lib';

export const navigateTo = createAction(
  "[Router] Navigate To Menu Item",
  props<{ path: string; id?: string }>()
);

export const basicNavigateTo = createAction(
  "[Router] Basic Navigation To Menu Item",
  props<{ path: string }>()
);

export const navigateToLocalUnitDetail = createAction(
  "[Router] Navigate To Local Unit Detail",
  props<LocalUnit>()
);

export const navigateToEditUnit = createAction(
  "[Router] Navigate Edit Unit",
  props<{ localUnit: LocalUnit }>()
);

export const navigateToTicketDetail = createAction(
  "[Router] Navigate To Ticket Detail",
  props<{ ticket: Ticket }>()
);

export const navigateToUserDetail = createAction(
  "[Router] Market Navigate To User Detail",
  props<{ user: User }>()
);

export const navigateToEditUser = createAction(
  "[Router] Market Navigate To Edit User",
  props<{ user: User }>()
);

export const navigateToCustomerDetail = createAction(
  "[Router] Market Navigate To Customer Detail",
  props<{ id: number }>()
);

export const navigateToContractualizeCustomer = createAction(
  "[Router] Market Navigate To Contractualize Customer",
  props<{ id: number }>()
);

export const navigateToEditCustomerPaymentNote = createAction(
  "[Router] Market Navigate To Edit Customer Payment",
  props<{ id: number }>()
);

export const navigateToServiceDetail = createAction(
  "[Router] Market Navigate To Service Detail",
  props<{ service: Service }>()
);

export const navigateToServiceGraph = createAction(
  "[Router] Market Navigate To Service Graph",
  props<{ service: Service }>()
);

export const navigateToAssociateService = createAction(
  "[Router] Market Navigate To Associate Service",
  props<{ service: Service }>()
);

export const navigateToEditService = createAction(
  "[Router] Market Navigate To Edit Service Name",
  props<{ service: Service }>()
);

export const navigateToPaymentsDetail = createAction(
  "[Router] Navigate To Payment Detail",
  props<Payment>()
);

export const navigateToInternalFeeDetail = createAction(
  "[Router] Navigate To Internal Fee Detail",
  props<{ rataSmallpayId: number }>()
);

export const navigateToExternalFeeDetail = createAction(
  "[Router] Navigate To External Fee Detail",
  props<{ rataSmallpayId: number }>()
);

export const navigateToReceiptDetail = createAction(
  "[Router] Navigate To Receipt Detail",
  props<{ receipt: Receipt }>()
);

export const navigateToSellPreview = createAction(
  "[Router] Navigate To Sell Preview",
  props<{ idOperation: string }>()
);

export const navigateToConcludeSelling = createAction(
  "[Router] Navigate To Conclude Selling",
  props<{ idOperation: string }>()
);

export const navigateToEditProduct = createAction(
  "[Router] Navigate To Edit Product",
  props<{ productId: number }>()
);

export const navigateToGateways = createAction(
  "[Router] Navigate To Gateways"
);

export const navigateToGateway = createAction(
  "[Router] Navigate To Gateway",
  props<{ serviceId: number }>()
);

export const navigateToAddGateway = createAction(
  "[Router] Navigate To Add Gateway"
);

export const navigateToConfigurePos = createAction(
  "[Router] Navigate To Physical Pos Configuration",
  props<{ idLocalUnit: number }>()
);

export const activateMenuItem = createAction(
  "[Router] Activate Menu Item",
  props<{ menuItemId: string }>()
);

export const storeItemToNavigationLog = createAction(
  "[Router] Store Item To Navigation Log",
  props<{ routingObject: { path: string; id: string } }>()
);
